import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// This component protects routes that require authentication
const ProtectedRoute = () => {
  const { isAuthenticated } = useAuth();
  
  // If user is not authenticated, redirect to login page
  // Otherwise, render the child routes
  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
